export enum UserType {
  Admin = 'ADMIN',
  DLS = 'DLS',
  FK = 'FK',
  DY = 'DY',
  SHH = 'SHH',
  SH = 'SH'
}
